import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Meeting } from "@app/models/rest/meeting";

@Injectable({
  providedIn: "root"
})
export class MeetingRestService extends HateoasResourceOperation<Meeting> {
  constructor() {
    super(Meeting);
  }
}
